module.exports = __webpack_public_path__ + "static/Hayne-c1abe777d74ef93bc824944485687f9b.jpg";